// Which month the Costs screen is describing, and whether it is this one.
//
// The screen shows the newest month the cost feed has written, because that is the only month
// there is data for. When the feed has not written since the month turned, that month is over,
// so "this month" and a projection to the end of it are both claims about a month that is not
// the current one. This says so, once, in a form the screen can act on.

/** `YYYY-MM` for a date, in UTC like the cost records' own period. */
export function monthOf(date) {
  return new Date(date).toISOString().slice(0, 7);
}

/** The first day of the month `period` names and of the one after it, as `YYYY-MM-DD`: the
 *  half-open range `[from, to)` a run's date must fall in to belong to that month. A past month
 *  has an end, and a sum with only a start counts every run since, which is how "2026-09" came to
 *  include October's and November's. */
export function monthBounds(period) {
  const m = /^(\d{4})-(\d{2})$/.exec(String(period || ""));
  if (!m) return { from: "", to: "" };
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const day = (year, month) => new Date(Date.UTC(year, month - 1, 1)).toISOString().slice(0, 10);
  return { from: day(y, mo), to: mo === 12 ? day(y + 1, 1) : day(y, mo + 1) };
}

/** True when the month shown is before the current one, so nothing on it is "this month". */
export function isPastMonth(period, now = new Date()) {
  return Boolean(period) && /^\d{4}-\d{2}$/.test(period) && period < monthOf(now);
}

/** What to call the month shown: "this month" only when it is. */
export function monthWord(period, now = new Date()) {
  return isPastMonth(period, now) ? period : "this month";
}
